import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { DocumentsCard } from "../Cards/DocumentsCard";
import { InfoBar } from "../InfoBar";
import { Loading } from "../../shared-components/Loading/Loading";
import { NotFound } from "../../shared-components/NotFound";
import DocLibContext from "../../../../application/Context/DocLibContext";
import { Pagination } from "../../../react-components/doc-lib-components/Pagination";
import { motion } from "framer-motion";
export var Documents = function () {
    var _a = useContext(DocLibContext), docs = _a.docs, docsIsLoading = _a.docsIsLoading, count = _a.count;
    return docsIsLoading ? (_jsx(Loading, {})) : docs.length > 0 ? (_jsxs(React.Fragment, { children: [_jsxs(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 }, exit: { opacity: 0 }, children: [_jsx(InfoBar, { elements: count }), docs.map(function (doc, i) { return (_jsx(DocumentsCard, { item: doc }, i)); })] }), _jsx(Pagination, {})] })) : (_jsxs(React.Fragment, { children: [_jsx(InfoBar, { elements: count }), _jsx(NotFound, {})] }));
};
